import { FC } from "react";
import { makeStyles } from "@mui/styles";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button, Box, IconButton } from "@mui/material";
import { deleteFolder, deleteNote } from "../../../services/notes.service";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as AlertIcon } from "../../../assets/alert.svg";

interface DeletePopoverProps {
  isOpen: boolean;
  onClose: () => void;
  entityType: "folder" | "note";
  deletableData: any;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: 460,
    height: 260,
    padding: 16,
  },
  closeIconContainer: {
    height: 40,
    position: "absolute",
    right: "5px",
    top: "5px",
  },
  contentContainer: {
    height: "calc(100% - 80px)",
  },
  actionContainer: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  alertIconContainer: {
    height: 72,
    padding: "5px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px"
  },
  TextContainer: {
    padding: 5,
    textAlign: "center",
  },
}));

const DeletePopover: FC<DeletePopoverProps> = ({ isOpen, onClose, entityType, deletableData }) => {
  const classes = useStyles();
  // const message =
  //   entityType === "folder"
  //     ? "Are you sure you want to delete this folder? All notes inside this folder will also be deleted."
  //     : "Are you sure you want to delete this note? This action cannot be undone.";

  const handleOnConfirm = async () => {
    try {
      const deleteAction = entityType === "folder" ? deleteFolder : deleteNote;
      const data: any = await deleteAction(deletableData?.id);

      if (data?.statusCode === 200) {
        toast.success(data?.message);
        onClose();
      } else {
        toast.error(data?.message || "Failed to delete.");
      }
    } catch (e) {
      console.error("Error while deleting:", e);
      toast.error("An error occurred while deleting.");
    }
  }

  return (
    <>
      {/* // <Dialog open={isOpen} onClose={onClose} className="delete-dialog-box" >
    //   {entityType === "folder" ?
    //     <DialogTitle className="title" >Delete {deletableData?.name} Folder</DialogTitle>
    //     : <DialogTitle className="title" > Delete {deletableData?.title} Note</DialogTitle>}
    //   <DialogContent>
    //     <Typography>{message}</Typography>
    //   </DialogContent>
    //   <DialogActions>
    //     <Button variant="contained" onClick={onClose} color="primary">Cancel</Button>
    //     <Button variant="contained" onClick={handleOnConfirm} color="error">Delete</Button>
    //   </DialogActions>
    // </Dialog> */}
      <Dialog open={isOpen} className="delete-dialog-box">
        <DialogContent className={classes.dialogContent}>
          <Box className={classes.closeIconContainer}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={classes.contentContainer}>
            <Box className={classes.alertIconContainer}>
              <AlertIcon />
            </Box>
            <Box className={`${classes.TextContainer} text-container`}>{"Are you sure that you want to delete the selected item?"}</Box>
          </Box>
          <Box className={classes.actionContainer}>
            <Button className="secondary-btn" style={{ width: "40%" }} onClick={onClose}>
              {"Cancel"}
            </Button>
            <Button className="primary-btn" style={{ width: "40%" }} onClick={handleOnConfirm}>
              {"Delete"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DeletePopover;
